import React, { FunctionComponent, useMemo, useState } from 'react'
import { AutocompleteInput, Input, SuggestionItem } from '../../shared'
import { ContactsProfessionSearchProps } from './ContactsProfessionSearch.model'
import styles from './ContactsProfessionSearch.module.scss'

export const ContactsProfessionSearch: FunctionComponent<ContactsProfessionSearchProps> = ({
  search,
  colorPreset,
  loading,
  listOfProfessions,
  disabled,
  onSearch,
}) => {
  const [focused, setFocused] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState<number>()

  const filteredOptions = useMemo(
    () =>
      !!search
        ? listOfProfessions.filter(({ description }) =>
            description.toLocaleLowerCase().includes(search.toLocaleLowerCase()),
          )
        : listOfProfessions,
    [listOfProfessions, search],
  )

  return (
    <AutocompleteInput
      selectedIndex={selectedIndex}
      predictionsLength={filteredOptions.length}
      suggestionsShown={focused}
      setSelectedIndex={setSelectedIndex}
      handlePressEnter={() => {
        if (selectedIndex !== undefined && filteredOptions[selectedIndex]) {
          setFocused(false)
          onSearch(filteredOptions[selectedIndex].description)
        }
      }}
      renderInput={(SuggestionContainer) => (
        <>
          <Input
            type="search"
            name="contactProfession"
            label="Spécialité médicale"
            onFocus={() => {
              setFocused(true)
            }}
            onBlur={() => setFocused(false)}
            colorPreset={colorPreset}
            value={search}
            onChange={(e) => onSearch(e.currentTarget.value)}
            disabled={disabled}
          />
          {focused && (
            <SuggestionContainer>
              {loading ? (
                <SuggestionItem>
                  <div className={styles.contactProfessionSearchItem}>Chargement...</div>
                </SuggestionItem>
              ) : (
                filteredOptions.map((item, index) => (
                  <SuggestionItem
                    key={item.id}
                    hover={index === selectedIndex}
                    onClick={() => onSearch(item.description)}
                  >
                    <div className={styles.contactProfessionSearchItem}>{item.description}</div>
                  </SuggestionItem>
                ))
              )}
            </SuggestionContainer>
          )}
        </>
      )}
      testId="autocomplete_input-contact-profession-search"
    />
  )
}
